<template>
  <div class="efo_act_wrap">
    <div class="content">
      <div 
        class="title"
        :class="bigSizeTitle ? 'big_size' : ''"
      >{{title}}</div>
      <div class="time" v-if="isShowTime">
        <span>{{$t('FoodC_dish_XX_YY_opCV')}}</span>
        <svg xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" class="svg_time" style="vertical-align:middle"><g fill="#fff"><path d="M24 5.5C13.23 5.5 4.5 14.23 4.5 25S13.23 44.5 24 44.5 43.5 35.77 43.5 25 34.77 5.5 24 5.5zm0 3c9.113 0 16.5 7.387 16.5 16.5S33.113 41.5 24 41.5 7.5 34.113 7.5 25 14.887 8.5 24 8.5z"/><path d="M10.966 39.058a1.5 1.5 0 0 1 2.174 2.062l-.106.111-3 2.856a1.5 1.5 0 0 1-2.174-2.062l.106-.112 3-2.855zM8.94 3.94a1.5 1.5 0 0 1 2.224 2.007l-.103.114-6 6a1.5 1.5 0 0 1-2.225-2.008l.103-.114 6-6zm30.12 0a1.5 1.5 0 0 0-2.224 2.007l.103.114 6 6a1.5 1.5 0 0 0 2.225-2.008l-.103-.114-6-6zm-2.026 35.118a1.5 1.5 0 0 0-2.174 2.062l.106.111 3 2.856a1.5 1.5 0 0 0 2.174-2.062l-.106-.112-3-2.855zM24 15.5a1.5 1.5 0 0 1 1.493 1.356L25.5 17v7.533l5.275 3.183a1.5 1.5 0 0 1 .578 1.932l-.069.127a1.5 1.5 0 0 1-1.932.578l-.127-.069-6-3.62a1.5 1.5 0 0 1-.717-1.127l-.008-.157V17a1.5 1.5 0 0 1 1.5-1.5z"/></g></svg>
        <span>{{time}}</span>
      </div>
      <div class="rules" @click="handleShowPop">
        {{ruleTitle}}<i class="icon-outline_entrance"></i>
      </div>
    </div>
    <EFOPopup 
      v-model="isShowPop" 
      :title="ruleTitle"
      :content="ruleContent"
    />

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { secondToDate } from '@/utils/tools';
import { isNumber } from '@/utils/types';
import EFOPopup from './efoPopup.vue';

export default {
  name: 'efoActBanner',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    EFOPopup,
  },
  computed: {
    ...mapState({
      isH5: ({common}) => common.isH5,
    }),
    title() {
      return this.data?.title || ''
    },
    bigSizeTitle() {
      return this.title.length > 6 ? false : true
    },
    ruleTitle() {
      return this.data?.ruleTitle
    },
    ruleContent() {
      return this.data?.ruleContent
    },
    countDownDesc() {
      return this.data?.countDownDesc
    },
    countDownSecond() {
      return this.data?.countDownSecond
    }
  },
  watch: {
    countDownSecond:{
      handler(newV){
        if (newV && isNumber(newV) && newV > 1) {
          this.compTime(newV)
        }
      },
      immediate:true
    },
  },
  data() {
    return {
      isShowTime: false,
      second: 0,
      time: '',
      t: '',
      isShowPop: false,
    }
  },
  mounted() {
  },
  methods: {
    handleShowPop() {
      this.isShowPop = true;
    },
    compTime(newV) {
      this.time = secondToDate(newV)
      this.second = newV - 1;
      this.isShowTime = true
      this.t = setInterval(() => {
        if (this.second < 1) {
          clearInterval(this.t)
          this.isShowTime = false;
          window.location.reload();
        } else {
          this.time = secondToDate(this.second);
          this.second --;
        }
      }, 1000);
    },
  },
  destroyed() {
    clearInterval(this.t)
  }
}
</script>

<style lang="scss" scoped>
.efo_act_wrap {
  width: 1156px;
  height: 289px;
  background-image: url('../Efo/imgs/pc_banner.png');  
  background-size: 100% 100%;
}

.content {
  padding-left: 10px;
  height: 100%;
  display: flex;
  flex-direction:column;
  justify-content: center;
  .title {
    max-width: 620px;
    margin-bottom: 20px;
    font-family: 'Aspira Medium';
    font-weight: 500;
    margin-right: 8px;
    font-size: 40px;
    line-height: 44px;
    color: #fff;
    @include ellipsis(2);
  }
  .time {
    margin-bottom: 20px;
    font-family: 'Aspira Medium';
    font-weight: 500;
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #fff;
    .text {
      margin-right: 8px;
    }
    .svg_time {
      margin-left: 4px;
      margin-right: 2px;
      width: 18px;
      height: 18px;
      vertical-align:middle;
    }
  }
  .rules {
    display: flex;
    align-items: center;
    font-family: 'Aspira Light';
    cursor: pointer;
    font-size: 20px;
    color: #FFFFFF;
    font-weight: 200;
    i {
      margin-left: 4px;
      font-size: 18px;
    }
  }
}

@media screen and (max-width: 768px){
  .efo_act_wrap {
    width: 100%;
    height: rem(536);
    background-image: url('../Efo/imgs/banner.png');  
    background-size: 100% 100%;
  }
  .content {
    padding-left: rem(40);
    .title {
      width: rem(406);
      font-size: rem(48);
      letter-spacing: 0;
      line-height: rem(66);
      margin-bottom: rem(32);
      &.big_size {
        font-size: rem(60);
      }
    }
    .time {
      margin-bottom: rem(44);
      font-size: rem(32);
    }
    .rules {
      font-size: rem(32);
    }
  }
}
</style>
